/**
 * Created by toomasp on 16.12.2016.
 */
import Injectable = angular.Injectable;
import ITemplateCacheService = angular.ITemplateCacheService;
import { ensureNg1Module } from "../util/ng-helper";

export let Ng1Component = (definition: {
    name: string,
    module: string,
    moduleNamespace?: string,
    moduleDependencies?: string[],
    template: string | Injectable<(...args: any[]) => string>,
    controllerAs?: string,
    bindings?: {},
    transclude?: boolean | { [slot: string]: string },
    translations?: { default: any } | any,
    translationNamespace?: string,
    require?: { [controller: string]: string },
    cacheTemplates?: { [fn: string]: string }
}) => {
    return (controller) => {
        let name = definition.name;
        if (name.indexOf("-") > -1)
            name = name.replace(/-\w/gi, (m) => m.slice(1).toUpperCase());

        let module: ng.IModule = ensureNg1Module((definition.moduleNamespace || 'eservice.ui') + '.' + definition.module, definition.moduleDependencies)
            .component(name, {
                controller,
                controllerAs: definition.controllerAs || "ctrl",
                template: definition.template,
                bindings: definition.bindings,
                transclude: definition.transclude || false,
                require: definition.require || {}
            });

        if (!!definition.translations) {
            let translations = definition.translations.default || definition.translations;
            module.run(['translator', (translator) => {
                return translator.appendTranslations(definition.translationNamespace || definition.module, translations);
            }]);
        }

        if (!!definition.cacheTemplates) {
            module.run(['$templateCache', ($templateCache: ITemplateCacheService) => {
                Object.keys(definition.cacheTemplates)
                    .forEach(k => {
                        $templateCache.put(k, definition.cacheTemplates[k]);
                    });
            }]);
        }
    }
};



// WEBPACK FOOTER //
// ./src/ui/core/common/decorators/Ng1Component.ts